const init = function () {
    if ($(".ryv-wrapper").length > 0) {
        if ($(".ryv-consent").length > 0) {
            var consented = false;
            $(".ryv-controls").hide();
            $(".ryv-consent").on('change', function () {
                if (this.checked && !consented) {
                    consented = true;
                    $(".ryv-controls").show();
                    fetch($(this).parents('.ryv-consent-wrapper').data('url'), {
                        method: 'POST'
                    });
                    $(".ryv-consent-head:not(.collapsed)").click();
                    launch();
                }
            });
        } else {
            launch();
        }
    }
};

function launch() {
    const $a2c = $('.add-to-cart-emb a.btn-primary');
    const $bb = $('.ryv-BB');
    const $set = $('input#ryvID');
    if ($a2c.length) {
        $a2c.data('link', $a2c.attr('href')).prop('disabled', true);
        $a2c.after('<div class="text-center ryv-selected"></div>');
    }
    $('.ryv-wrapper').on('click', '.ryvSelect', function () {
        $('.ryv-selected').text('Selected recording: ' + $(this).siblings('input').val()).css('margin', '8px 0 0');
        $('.ryvAccept').remove();
        if ($('.priorrecords').length > 0) {
            $('.priorrecords').val('');
        }
        if ($set.length) {
            $set.val($(this).data('ryvid'));
            $('.ryv-selected').data('ryvName', $(this).siblings('input').val());
        } else if ($a2c.length) {
            $a2c.attr('href', $a2c.data('link') + '&ryvID=' + $(this).data('ryvid') + '&ryvName=' + $(this).siblings('input').val()).prop('disabled', false);
        } else if ($bb.length) {
            setBB($(this).data('ryvid'), $(this).siblings('input').val());
        }
        $('.ryvSelect').show(); // show all other selects
        $(this).hide(); // hide this select
    });
    if ($('.priorrecords').length > 0) {
        $('.priorrecords').on('change', function () {
            if ($(this).val()) {
                $('.ryvSelect').show(); // show all other selects
                $('.ryv-selected').text('Selected recording: ' + $(this).children(':selected').text()).css('margin', '8px 0 0');
                if ($set.length) {
                    $set.val($(this).val());
                    $('.ryv-selected').data('ryvName', $(this).children(':selected').text());
                } else if ($a2c.length) {
                    $a2c.attr('href', $a2c.data('link') + '&ryvID=' + $(this).val() + '&ryvName=' + $(this).children(':selected').text()).show().prop('disabled', false);
                } else if ($bb.length) {
                    setBB($(this).val(), $(this).children(':selected').text());
                }
            }
        });
    }
    if (navigator.mediaDevices.getUserMedia) {
        let chunks = [];
        let blob;
        let constraints = {
            audio: true
        };
        let options = { mimeType: "audio/mp4" };
        let blobType = 'audio/mp4';
        let audioCount = 0;
        let audioIDs = [];
        let timerInterval;
        navigator.mediaDevices.enumerateDevices().then((devices) => {
            const menu = $("select.inputdevices");
            devices.forEach((device) => {
                if (device.kind === "audioinput" && audioIDs.indexOf(device.label.split('(').pop()) == -1) {
                    audioCount++;
                    const item = document.createElement("option");
                    item.textContent = device.label;
                    item.value = device.deviceId;
                    audioIDs.push(device.label.split('(').pop());
                    menu.append(item);
                }
            });
            if (audioCount == 0) {
                // no input
                menu.hide();
                console.log("No audio in detected.");
                $(".ryv-wrapper .sound-clips").append("No microphone detected.");
            } else if (audioCount == 1) {
                menu.hide();
                $(".ryv-wrapper .buttons").show();
                console.log("Just one audio in detected, using it.");
                navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
            } else {
                $(".ryv-wrapper .buttons").show();
                console.log("Multiple audio in detected, using default.");
                $('.inputdevices option').eq(1).prop('selected', true);
                constraints.deviceId = $('.inputdevices').val();
                navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
            }
        });
        let onSuccess = function (stream) {
            var mediaRecorder;
            const $record = $(".ryv-controls .record");
            const $stop = $(".ryv-controls .stop");
            const $soundClips = $(".ryv-wrapper .sound-clips");
            try {
                mediaRecorder = new MediaRecorder(stream, options);
            } catch (err) {
                console.log("MediaRecorder creation failed once. " + err.message);
                options = { mimeType: "audio/mp4" };
                try {
                    mediaRecorder = new MediaRecorder(stream, options);
                    blobType = 'audio/mp4';
                } catch (err) {
                    $(".ryv-wrapper .sound-clips").append(err.message);
                    console.log("MediaRecorder creation failed twice. " + err.message);
                    $record.prop('disabled', true).hide();
                    return;
                }
            }
            $stop.prop('disabled', true).hide();

            $record.off('click');
            $record.on('click', function () {
                mediaRecorder.start();
                timerInterval = startTimer(stream);
                $stop.show();
                $record.prop('disabled', true).hide();
            });
            $stop.off('click');
            $stop.on('click', function () {
                clearInterval(timerInterval);
                $('.ryv-timer').text('');
                mediaRecorder.stop();
                $stop.prop('disabled', true).hide();
                $record.prop('disabled', false).show();
            });

            mediaRecorder.onstop = function () {
                let clipName = 'Unnamed Recording';

                const clipContainer = document.createElement("article");
                const clipLabel = document.createElement("input");
                const clipLabelLabel = document.createElement("label");
                const audio = document.createElement("audio");
                const deleteButton = document.createElement("button");
                const submitButton = document.createElement("button");

                clipContainer.classList.add("clip", "floating-label");
                deleteButton.textContent = "Delete";
                deleteButton.className = "ryvDelete btn btn-outline-primary";
                submitButton.textContent = "Submit";
                submitButton.className = "ryvSubmit btn btn-primary";
                clipLabel.className = "form-control";
                clipLabel.id = 'clipName';
                clipLabel.value = clipName;
                clipLabelLabel.setAttribute('for', 'clipName');
                clipLabelLabel.textContent = 'Name: ';

                clipContainer.appendChild(clipLabelLabel);
                clipContainer.appendChild(clipLabel);
                clipContainer.appendChild(audio);
                clipContainer.appendChild(deleteButton);
                clipContainer.appendChild(submitButton);
                $soundClips.append(clipContainer);
                $('.buttons .record').prop('disabled', true);

                audio.controls = true;
                blob = new Blob(chunks, { type: blobType });
                chunks = [];
                audio.src = window.URL.createObjectURL(blob);
                console.log("recorder stopped");
                $('.ryvSubmit').last().data('blob', blob);

                deleteButton.onclick = function (e) {
                    $('.ryvSubmit').last().data('blob', '');
                    e.target.closest(".clip").remove();
                    $('.buttons .record').prop('disabled', false);
                    $('.ryvAccept, .ryvReject').remove();
                };
                submitButton.onclick = function () {
                    var $that = $(this),
                        clipName = $that.parent().children('input').val() || 'Nameless Recording';
                    $.spinner().start();
                    $('.ryv-tester').hide();
                    let url = $(".ryv-controls").data('url');
                    url += '?loyaltyNum=' + $('.ryv-loyalty').val();
                    $.ajax({
                        url: url,
                        type: 'GET',
                        success: function (response) {
                            var reqForm = new FormData();
                            reqForm.append('fileName', clipName);
                            reqForm.append('loyaltyNum', $('.ryv-loyalty').val());
                            reqForm.append('security', response.key);
                            reqForm.append('dateTime', response.time);
                            reqForm.append('wav', $that.data('blob'), clipName);
                            if ($('.ryv-account-redo').length) {
                                reqForm.append('ryvNum', $('.ryv-id').val());
                            }
                            fetch($(".ryv-controls").data('process'), {
                                method: 'POST',
                                body: reqForm
                            })
                                .then(resp => {
                                    if (resp.status !== 200) {
                                        console.log("!success" + resp.status);
                                        $.spinner().stop();
                                        resp.text().then((respRaw) => {
                                            console.log(respRaw);
                                            var respJson = JSON.parse(respRaw);
                                            console.log(respJson);
                                        });
                                    } else {
                                        resp.text().then((respRaw) => {
                                            var respJson = JSON.parse(respRaw);
                                            $.spinner().stop();
                                            if (respJson.hasError) {
                                                $('.ryvAccept, .ryvReject').remove();
                                                if (respJson.errorReason.length) {
                                                    if (respJson.errorReason.indexOf('Copyrighted Materials') > -1) {
                                                        $that.after('<span class="ryvReject">We\'re sorry, your message could not be saved. Please rerecord and try again. Recordings not meeting our content guidelines, including copyrighted materials and profanity are not permitted.</span>');
                                                    } else {
                                                        $that.after('<span class="ryvReject">We\'re sorry, your message could not be saved. Please rerecord and try again. Recordings not meeting our content guidelines, including copyrighted materials and profanity are not permitted.</span>');
                                                    }
                                                } else {
                                                    $that.after('<span class="ryvReject">We\'re sorry, there was a technical error, please check your recording. If it sounds good yet continues to fail, try rerecording.</span>');
                                                }
                                            } else if ($('.ryv-account-redo').length) {
                                                $that.parent().after('New recording accepted, Thank you. You may now close or leave this page.');
                                                $that.parent().hide();
                                            } else {
                                                $('.ryvSelect').show();
                                                $('.ryvAccept, .ryvReject').remove();
                                                $that.after('<button class="ryvSelect btn btn-primary" data-ryvid=' + respJson.ryvNum + ' style="display: none;">Select</button><span class="ryvAccept"><i class="iconoir-check"></i>Your \"' + clipName + '\" has been successfully uploaded.</span>');
                                                $that.parent().children('.ryvDelete').hide();
                                                $that.hide();
                                                $('.ryv-selected').text('Selected recording: ' + clipName).css('margin', '8px 0 0');
                                                $that.parent().children('input').prop('disabled', true);
                                                $('.buttons .record').prop('disabled', false);
                                                if ($('.priorrecords').length > 0) {
                                                    $('.priorrecords').val('');
                                                }
                                                if ($set.length) {
                                                    $set.val(respJson.ryvNum);
                                                    $('.ryv-selected').data('ryvName', clipName);
                                                } else if ($a2c.length) {
                                                    $a2c.attr('href', $a2c.data('link') + '&ryvID=' + respJson.ryvNum + '&ryvName=' + clipName).show().prop('disabled', false);
                                                } else if ($bb.length) {
                                                    setBB(respJson.ryvNum, clipName);
                                                }
                                            }
                                        });
                                    }
                                })
                                .catch(err => {
                                    $('.ryvAccept, .ryvReject').remove();
                                    if (err.toString().indexOf('fetch') >= 0) {
                                        $(".ryv-wrapper .sound-clips").append('<span class="ryvReject">We\'re sorry, your upload failed. Please try again.</span>');
                                    } else {
                                        $(".ryv-wrapper .sound-clips").append('<span class="ryvReject">Error: ' + err + '</span>');
                                    }
                                    console.log(err);
                                    $.spinner().stop();
                                });
                        },
                        error: function (err) {
                            console.log(err);
                            $.spinner().stop();
                        }
                    });
                };
            };

            mediaRecorder.ondataavailable = function (e) {
                chunks.push(e.data);
            };
        };

        let onError = function (err) {
            if (err.toString().indexOf('Permission') >= 0) {
                $(".ryv-wrapper .sound-clips").append('<span class="ryvReject">Microphone permission missing. Please ensure microphone access is enabled for both buildabear.com and your browser.</span>');
            } else {
                $(".ryv-wrapper .sound-clips").append("The following error occurred: " + err);
            }
        };

        $('.inputdevices').on('change', function () {
            console.log("input device changed to: " + $('.inputdevices').val());
            constraints.deviceId = $('.inputdevices').val();
            $(".ryv-wrapper .buttons").show();
            navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
        });
    } else {
        $(".ryv-wrapper .sound-clips").append("Recording not supported on your browser");
    }
}

function startTimer(stream) {
    window.AudioContext = window.AudioContext || window.webkitAudioContext;
    let audioCtx = new window.AudioContext();
    const source = audioCtx.createMediaStreamSource(stream);
    const analyser = audioCtx.createAnalyser();
    analyser.fftSize = 2048;
    const bufferLength = analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);
    source.connect(analyser);
    let detected = 0;
    let timer = 30;
    $('.ryv-timer').text(timer);
    $('.ryv-tester').hide();
    var timerInterval = setInterval(() => {
        timer = timer -= 1;
        $('.ryv-timer').text(timer);
        if (timer === 24) {
            $(".ryv-controls .stop").prop('disabled', false);
        } else if (timer === 0) {
            $(".ryv-controls .stop").trigger('click');
        }
    }, 1000);
    var detectionInterval = setInterval(() => {
        analyser.getByteTimeDomainData(dataArray);
        let min = 256;
        let max = 0;
        for (let i = 0; i < bufferLength; i++) {
            let u = dataArray[i];
            min = u < min ? u : min;
            max = u > max ? u : max;
        }
        if (max - min >= 12) {
            detected++;
        }
        $('.ryv-tester').text('min: ' + min + ' max: ' + max + ' detected: ' + detected);
        if (timer == 27) {
            clearInterval(detectionInterval);
            $('.ryv-tester').html('Audio Quality: ' + (detected > 90 ? 'Good' : detected > 1 ? 'Seems quiet<br/>Try moving closer to your mic, or check your mic settings.' : 'No Sound<br/>No audio detected. Check your mic and permission settings.')).show(); //eslint-disable-line
        }
    }, 10);
    return timerInterval;
}

function setBB(ryvID, ryvName) {
    $.ajax({
        url: $('.ryv-BB').data('url'),
        method: 'POST',
        data: {
            ryvID: ryvID,
            ryvName: ryvName
        },
        success: function () {
            $('.ryv-selected').data('ryvid', ryvID);
        }
    });
}

module.exports = {
    init: init
};
